/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

// eslint-disable-next-line camelcase
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-base-common">
    <template>
		<custom-style>
			<style>
                *,
                ::after,
                ::before,
                :host {
                    box-sizing: border-box
                }

                :host {
                    color: var(--cs-dark-color);
                    font-family: var(--cs-theme-primary-font-family);
                    font-size: var(--cs-theme-body-font-size-mobile);
                    -webkit-font-smoothing: antialiased;
                    line-height: var(--cs-theme-body-line-height-mobile)
                }

                :host([text-color=light]) {
                    color: var(--cs-light-color)
                }

                @media only screen and (min-width:1024px) {
                    :host {
                        font-size: var(--cs-theme-body-font-size-tablet-landscape);
                        line-height: var(--cs-theme-body-line-height-tablet-landscape)
                    }
                }

                @media only screen and (min-width:1456px) {
                    :host {
                        font-size: var(--cs-theme-body-font-size-desktop);
                        line-height: var(--cs-theme-body-line-height-desktop)
                    }
                }

                [hidden] {
                    display: none !important
                }


                :host {
                    --cs-interface-expansion: 0.1s;
                    --cs-transition-duration: 0.3s;
                    --cs-transition-easing: cubic-bezier(0.25, 0.1, 0.25, 1)
                }

                :host {
                    --cs-theme-color: var(--cs-theme-color);
                    --cs-theme-dark-gradient: var(--cs-theme-color);
                    --cs-theme-light-gradient: var(--cs-theme-color);
                    --cs-theme-primary-font-family: "roboto";
                    --cs-theme-secondary-font-family: "roboto-condensed";
                    --cs-theme-typographic-headings-font-family: var(--cs-theme-secondary-font-family);
                    --cs-text-case: uppercase;
                    --cs-theme-body-font-size-mobile: 16px;
                    --cs-theme-body-font-size-tablet-landscape: 18px;
                    --cs-theme-body-font-size-desktop: 18px;
                    --cs-theme-body-letter-spacing-mobile: normal;
                    --cs-theme-body-letter-spacing-tablet-landscape: normal;
                    --cs-theme-body-letter-spacing-desktop: normal;
                    --cs-theme-body-line-height-mobile: 24px;
                    --cs-theme-body-line-height-tablet-landscape: 26px;
                    --cs-theme-body-line-height-desktop: 28px;
                    --cs-theme-h1-font-weight: 200;
                    --cs-theme-h1-letter-spacing: -1px;
                    --cs-theme-h1-font-size-mobile: 40px;
                    --cs-theme-h1-font-size-tablet-landscape: 44px;
                    --cs-theme-h1-font-size-desktop: 48px;
                    --cs-theme-h1-letter-spacing-mobile: var(--cs-theme-h1-letter-spacing);
                    --cs-theme-h1-letter-spacing-tablet-landscape: -1px;
                    --cs-theme-h1-letter-spacing-desktop: -1px;
                    --cs-theme-h1-line-height-mobile: 52px;
                    --cs-theme-h1-line-height-tablet-landscape: 58px;
                    --cs-theme-h1-line-height-desktop: 62px;
                    --cs-theme-h1-margin-mobile: 30px 0;
                    --cs-theme-h1-margin-tablet-portrait: var(--cs-theme-h1-margin-mobile);
                    --cs-theme-h1-margin-tablet-landscape: 32px 0;
                    --cs-theme-h1-margin-desktop: 34px 0;
                    --cs-theme-h2-font-weight: 300;
                    --cs-theme-h2-letter-spacing: -.5px;
                    --cs-theme-h2-font-size-mobile: 32px;
                    --cs-theme-h2-font-size-tablet-landscape: 36px;
                    --cs-theme-h2-font-size-desktop: 40px;
                    --cs-theme-h2-letter-spacing-mobile: var(--cs-theme-h2-letter-spacing);
                    --cs-theme-h2-letter-spacing-tablet-landscape: -.5px;
                    --cs-theme-h2-letter-spacing-desktop: -.5px;
                    --cs-theme-h2-line-height-mobile: 40px;
                    --cs-theme-h2-line-height-tablet-landscape: 46px;
                    --cs-theme-h2-line-height-desktop: 50px;
                    --cs-theme-h2-margin-mobile: 26px 0;
                    --cs-theme-h2-margin-tablet-portrait: var(--cs-theme-h2-margin-mobile);
                    --cs-theme-h2-margin-tablet-landscape: 28px 0;
                    --cs-theme-h2-margin-desktop: 30px 0;
                    --cs-theme-h2-after-l2-margin-top-mobile: 11px;
                    --cs-theme-h2-after-l2-margin-top-tablet-landscape: 14px;
                    --cs-theme-h2-after-l2-margin-top-desktop: 17px;
                    --cs-theme-h3-font-weight: 300;
                    --cs-theme-h3-letter-spacing: normal;
                    --cs-theme-h3-font-size-mobile: 28px;
                    --cs-theme-h3-font-size-tablet-landscape: 32px;
                    --cs-theme-h3-font-size-desktop: 36px;
                    --cs-theme-h3-letter-spacing-mobile: var(--cs-theme-h3-letter-spacing);
                    --cs-theme-h3-letter-spacing-tablet-landscape: normal;
                    --cs-theme-h3-letter-spacing-desktop: normal;
                    --cs-theme-h3-line-height-mobile: 36px;
                    --cs-theme-h3-line-height-tablet-landscape: 40px;
                    --cs-theme-h3-line-height-desktop: 46px;
                    --cs-theme-h3-margin-mobile: 22px 0;
                    --cs-theme-h3-margin-tablet-portrait: var(--cs-theme-h3-margin-mobile);
                    --cs-theme-h3-margin-tablet-landscape: 24px 0;
                    --cs-theme-h3-margin-desktop: 26px 0;
                    --cs-theme-h4-font-weight: 300;
                    --cs-theme-h4-letter-spacing: normal;
                    --cs-theme-h4-font-size-mobile: 24px;
                    --cs-theme-h4-font-size-tablet-landscape: 28px;
                    --cs-theme-h4-font-size-desktop: 32px;
                    --cs-theme-h4-letter-spacing-mobile: var(--cs-theme-h4-letter-spacing);
                    --cs-theme-h4-letter-spacing-tablet-landscape: normal;
                    --cs-theme-h4-letter-spacing-desktop: normal;
                    --cs-theme-h4-line-height-mobile: 32px;
                    --cs-theme-h4-line-height-tablet-landscape: 36px;
                    --cs-theme-h4-line-height-desktop: 40px;
                    --cs-theme-h4-margin-mobile: 18px 0;
                    --cs-theme-h4-margin-tablet-portrait: var(--cs-theme-h4-margin-mobile);
                    --cs-theme-h4-margin-tablet-landscape: 20px 0;
                    --cs-theme-h4-margin-desktop: 22px 0;
                    --cs-theme-h4-after-d1-margin-top-mobile: 17px;
                    --cs-theme-h4-after-d1-margin-top-tablet-portrait: 20px;
                    --cs-theme-h4-after-d1-margin-top-tablet-landscape: 19px;
                    --cs-theme-h4-after-d1-margin-top-desktop: 17px;
                    --cs-theme-h4-after-d2-margin-top-mobile: 10px;
                    --cs-theme-h4-after-d2-margin-top-tablet-portrait: 16px;
                    --cs-theme-h4-after-d2-margin-top-tablet-landscape: 18px;
                    --cs-theme-h4-after-d2-margin-top-desktop: 22px;
                    --cs-theme-h4-after-d3-margin-top-mobile: 10px;
                    --cs-theme-h4-after-d3-margin-top-tablet-portrait: 18px;
                    --cs-theme-h4-after-d3-margin-top-tablet-landscape: 20px;
                    --cs-theme-h4-after-d3-margin-top-desktop: 22px;
                    --cs-theme-h4-after-d4-margin-top-mobile: 11px;
                    --cs-theme-h4-after-d4-margin-top-tablet-landscape: 13px;
                    --cs-theme-h4-after-d4-margin-top-desktop: 16px;
                    --cs-theme-h4-after-l2-margin-top-mobile: 13px;
                    --cs-theme-h4-after-l2-margin-top-tablet-landscape: 15px;
                    --cs-theme-h4-after-l2-margin-top-desktop: 19px;
                    --cs-theme-h5-font-weight: 300;
                    --cs-theme-h5-letter-spacing: normal;
                    --cs-theme-h5-font-size-mobile: 22px;
                    --cs-theme-h5-font-size-tablet-landscape: 24px;
                    --cs-theme-h5-font-size-desktop: 28px;
                    --cs-theme-h5-letter-spacing-mobile: var(--cs-theme-h5-letter-spacing);
                    --cs-theme-h5-letter-spacing-tablet-landscape: normal;
                    --cs-theme-h5-letter-spacing-desktop: normal;
                    --cs-theme-h5-line-height-mobile: 30px;
                    --cs-theme-h5-line-height-tablet-landscape: 32px;
                    --cs-theme-h5-line-height-desktop: 36px;
                    --cs-theme-h5-margin-mobile: 14px 0;
                    --cs-theme-h5-margin-tablet-portrait: var(--cs-theme-h5-margin-mobile);
                    --cs-theme-h5-margin-tablet-landscape: 16px 0;
                    --cs-theme-h5-margin-desktop: 18px 0;
                    --cs-theme-h5-after-l2-margin-top-mobile: 4px;
                    --cs-theme-h5-after-l2-margin-top-tablet-landscape: 5px;
                    --cs-theme-h5-after-l2-margin-top-desktop: 3px;
                    --cs-theme-h6-font-weight: 300;
                    --cs-theme-h6-letter-spacing: normal;
                    --cs-theme-h6-font-size-mobile: 20px;
                    --cs-theme-h6-font-size-desktop: 24px;
                    --cs-theme-h6-letter-spacing-mobile: var(--cs-theme-h6-letter-spacing);
                    --cs-theme-h6-letter-spacing-desktop: normal;
                    --cs-theme-h6-line-height-mobile: 28px;
                    --cs-theme-h6-line-height-desktop: 32px;
                    --cs-theme-h6-margin-mobile: 10px 0;
                    --cs-theme-h6-margin-tablet-portrait: var(--cs-theme-h6-margin-mobile);
                    --cs-theme-h6-margin-tablet-landscape: var(--cs-theme-h6-margin-tablet-portrait);
                    --cs-theme-h6-margin-desktop: 14px 0;
                    --cs-theme-h6-after-d3-margin-top-mobile: 10px;
                    --cs-theme-h6-after-d3-margin-top-tablet-landscape: 14px;
                    --cs-theme-h6-after-d3-margin-top-desktop: 16px;
                    --cs-theme-h6-after-l2-margin-top-mobile: 5px;
                    --cs-theme-ol-and-ul-padding-left-mobile: 0;
                    --cs-theme-nested-ol-and-ul-padding-left-mobile: 15px;
                    --cs-theme-nested-ol-and-ul-padding-left-tablet-landscape: 35px;
                    --cs-theme-li-margin-mobile: 8px 0;
                    --cs-theme-li-margin-tablet-landscape: 10px 0;
                    --cs-theme-ul-li-bullet-character: "\\2022";
                    --cs-theme-ul-li-bullet-margin-right-mobile: 10px;
                    --cs-theme-ul-li-bullet-margin-right-tablet-landscape: 20px;
                    --cs-theme-d1-letter-spacing: normal;
                    --cs-theme-d1-font-style: normal;
                    --cs-theme-d1-font-weight: bold;
                    --cs-theme-d1-font-size-mobile: 80px;
                    --cs-theme-d1-font-size-tablet-portrait: 120px;
                    --cs-theme-d1-font-size-tablet-landscape: 152px;
                    --cs-theme-d1-font-size-desktop: 200px;
                    --cs-theme-d1-letter-spacing-mobile: var(--cs-theme-d1-letter-spacing);
                    --cs-theme-d1-letter-spacing-tablet-portrait: normal;
                    --cs-theme-d1-letter-spacing-tablet-landscape: normal;
                    --cs-theme-d1-letter-spacing-desktop: normal;
                    --cs-theme-d1-line-height-mobile: 72px;
                    --cs-theme-d1-line-height-tablet-portrait: 108px;
                    --cs-theme-d1-line-height-tablet-landscape: 136px;
                    --cs-theme-d1-line-height-desktop: 180px;
                    --cs-theme-d1-after-h4-margin-top-mobile: 6px;
                    --cs-theme-d1-after-h4-margin-top-tablet-portrait: 2px;
                    --cs-theme-d1-after-h4-margin-top-desktop: -1px;
                    --cs-theme-d1-after-l2-margin-top-mobile: 10px;
                    --cs-theme-d1-after-l2-margin-top-tablet-portrait: 6px;
                    --cs-theme-d1-after-l2-margin-top-tablet-landscape: 10px;
                    --cs-theme-d1-after-l2-margin-top-desktop: 12px;
                    --cs-theme-d2-letter-spacing: normal;
                    --cs-theme-d2-font-style: normal;
                    --cs-theme-d2-font-weight: bold;
                    --cs-theme-d2-font-size-mobile: 58px;
                    --cs-theme-d2-font-size-tablet-portrait: 72px;
                    --cs-theme-d2-font-size-tablet-landscape: 85px;
                    --cs-theme-d2-font-size-desktop: 90px;
                    --cs-theme-d2-letter-spacing-mobile: var(--cs-theme-d2-letter-spacing);
                    --cs-theme-d2-letter-spacing-tablet-portrait: normal;
                    --cs-theme-d2-letter-spacing-tablet-landscape: normal;
                    --cs-theme-d2-letter-spacing-desktop: normal;
                    --cs-theme-d2-line-height-mobile: 60px;
                    --cs-theme-d2-line-height-tablet-portrait: 68px;
                    --cs-theme-d2-line-height-tablet-landscape: 80px;
                    --cs-theme-d2-line-height-desktop: 104px;
                    --cs-theme-d2-after-h4-margin-top-mobile: 6px;
                    --cs-theme-d2-after-h4-margin-top-tablet-landscape: 8px;
                    --cs-theme-d2-after-h4-margin-top-desktop: 7px;
                    --cs-theme-d2-after-l2-margin-top-mobile: 10px;
                    --cs-theme-d2-after-l2-margin-top-tablet-landscape: 16px;
                    --cs-theme-d2-after-l2-margin-top-desktop: 20px;
                    --cs-theme-d3-letter-spacing: normal;
                    --cs-theme-d3-font-style: normal;
                    --cs-theme-d3-font-weight: bold;
                    --cs-theme-d3-font-size-mobile: 48px;
                    --cs-theme-d3-font-size-tablet-portrait: 48px;
                    --cs-theme-d3-font-size-tablet-landscape: 60px;
                    --cs-theme-d3-font-size-desktop: 72px;
                    --cs-theme-d3-letter-spacing-mobile: var(--cs-theme-d3-letter-spacing);
                    --cs-theme-d3-letter-spacing-tablet-portrait: normal;
                    --cs-theme-d3-letter-spacing-tablet-landscape: normal;
                    --cs-theme-d3-letter-spacing-desktop: normal;
                    --cs-theme-d3-line-height-mobile: 48px;
                    --cs-theme-d3-line-height-tablet-portrait: 48px;
                    --cs-theme-d3-line-height-tablet-landscape: 56px;
                    --cs-theme-d3-line-height-desktop: 68px;
                    --cs-theme-d3-after-h4-margin-top-mobile: 8px;
                    --cs-theme-d3-after-h4-margin-top-tablet-landscape: 12px;
                    --cs-theme-d3-after-h4-margin-top-desktop: 13px;
                    --cs-theme-d3-after-h6-margin-top-mobile: 9px;
                    --cs-theme-d3-after-h6-margin-top-tablet-landscape: 13px;
                    --cs-theme-d3-after-h6-margin-top-desktop: 14px;
                    --cs-theme-d3-after-l2-margin-top-mobile: 12px;
                    --cs-theme-d3-after-l2-margin-top-tablet-landscape: 16px;
                    --cs-theme-d3-after-l2-margin-top-desktop: 18px;
                    --cs-theme-d4-letter-spacing: normal;
                    --cs-theme-d4-font-style: normal;
                    --cs-theme-d4-font-weight: bold;
                    --cs-theme-d4-font-size-mobile: 40px;
                    --cs-theme-d4-font-size-tablet-landscape: 44px;
                    --cs-theme-d4-font-size-desktop: 48px;
                    --cs-theme-d4-letter-spacing-mobile: var(--cs-theme-d4-letter-spacing);
                    --cs-theme-d4-letter-spacing-tablet-landscape: normal;
                    --cs-theme-d4-letter-spacing-desktop: normal;
                    --cs-theme-d4-line-height-mobile: 40px;
                    --cs-theme-d4-line-height-tablet-landscape: 44px;
                    --cs-theme-d4-line-height-desktop: 48px;
                    --cs-theme-d4-after-h4-margin-top-mobile: 9px;
                    --cs-theme-d4-after-h4-margin-top-tablet-portrait: 12px;
                    --cs-theme-d4-after-h4-margin-top-desktop: 15px;
                    --cs-theme-d4-after-l2-margin-top-mobile: 13px;
                    --cs-theme-d4-after-l2-margin-top-tablet-landscape: 16px;
                    --cs-theme-d4-after-l2-margin-top-desktop: 20px;
                    --cs-theme-b1-font-size-mobile: 20px;
                    --cs-theme-b1-font-size-tablet-portrait: var(--cs-theme-b1-font-size-mobile);
                    --cs-theme-b1-font-size-tablet-landscape: var(--cs-theme-b1-font-size-tablet-portrait);
                    --cs-theme-b1-letter-spacing-mobile: normal;
                    --cs-theme-b1-letter-spacing-tablet-portrait: normal;
                    --cs-theme-b1-letter-spacing-tablet-landscape: normal;
                    --cs-theme-b1-letter-spacing-desktop: normal;
                    --cs-theme-b1-font-size-desktop: 24px;
                    --cs-theme-b1-line-height-mobile: 28px;
                    --cs-theme-b1-line-height-tablet-portrait: var(--cs-theme-b1-line-height-mobile);
                    --cs-theme-b1-line-height-tablet-landscape: var(--cs-theme-b1-line-height-tablet-portrait);
                    --cs-theme-b1-line-height-desktop: 32px;
                    --cs-theme-b1-margin-mobile: 16px 0;
                    --cs-theme-b1-margin-tablet-portrait: var(--cs-theme-b1-margin-mobile);
                    --cs-theme-b1-margin-tablet-landscape: var(--cs-theme-b1-margin-tablet-portrait);
                    --cs-theme-b1-margin-desktop: 20px 0;
                    --cs-theme-b2-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                    --cs-theme-b2-font-size-tablet-portrait: var(--cs-theme-body-font-size-mobile);
                    --cs-theme-b2-font-size-tablet-landscape: var(--cs-theme-body-font-size-tablet-landscape);
                    --cs-theme-b2-font-size-desktop: var(--cs-theme-body-font-size-desktop);
                    --cs-theme-b2-letter-spacing-mobile: normal;
                    --cs-theme-b2-letter-spacing-tablet-portrait: normal;
                    --cs-theme-b2-letter-spacing-tablet-landscape: normal;
                    --cs-theme-b2-letter-spacing-desktop: normal;
                    --cs-theme-b2-line-height-mobile: var(--cs-theme-body-line-height-mobile);
                    --cs-theme-b2-line-height-tablet-portrait: var(--cs-theme-body-line-height-mobile);
                    --cs-theme-b2-line-height-tablet-landscape: var(--cs-theme-body-line-height-tablet-landscape);
                    --cs-theme-b2-line-height-desktop: var(--cs-theme-body-line-height-desktop);
                    --cs-theme-b2-margin-mobile: 8px 0;
                    --cs-theme-b2-margin-tablet-portrait: var(--cs-theme-b2-margin-mobile);
                    --cs-theme-b2-margin-tablet-landscape: 10px 0;
                    --cs-theme-b2-after-d1-margin-top-mobile: 17px;
                    --cs-theme-b2-after-d1-margin-top-tablet-portrait: 25px;
                    --cs-theme-b2-after-d1-margin-top-tablet-landscape: 14px;
                    --cs-theme-b2-after-d1-margin-top-desktop: 19px;
                    --cs-theme-b2-after-d2-margin-top-mobile: 10px;
                    --cs-theme-b2-after-d2-margin-top-tablet-portrait: 18px;
                    --cs-theme-b2-after-d2-margin-top-desktop: 26px;
                    --cs-theme-b2-after-d3-margin-top-mobile: 10px;
                    --cs-theme-b2-after-d3-margin-top-tablet-portrait: 18px;
                    --cs-theme-b2-after-d3-margin-top-desktop: 26px;
                    --cs-theme-b2-after-d4-margin-top-mobile: 11px;
                    --cs-theme-b2-after-d4-margin-top-tablet-landscape: 15px;
                    --cs-theme-b2-after-d4-margin-top-desktop: 19px;
                    --cs-theme-b2-after-h2-margin-top-mobile: 8px;
                    --cs-theme-b2-after-h2-margin-top-tablet-landscape: 10px;
                    --cs-theme-b2-after-h2-margin-top-desktop: 13px;
                    --cs-theme-b2-after-h4-margin-top-mobile: 9px;
                    --cs-theme-b2-after-h4-margin-top-tablet-landscape: 13px;
                    --cs-theme-b2-after-h4-margin-top-desktop: 16px;
                    --cs-theme-b2-after-h5-margin-top-mobile: 6px;
                    --cs-theme-b2-after-h5-margin-top-tablet-landscape: 5px;
                    --cs-theme-b2-after-h5-margin-top-desktop: 9px;
                    --cs-theme-b2-after-h6-margin-top-mobile: 6px;
                    --cs-theme-b2-after-h6-margin-top-desktop: 9px;
                    --cs-theme-b2-after-b2-margin-top-mobile: 0;
                    --cs-theme-b2-after-b2-margin-top-desktop: 1px;
                    --cs-theme-b2-after-b3-margin-top-mobile: 8px;
                    --cs-theme-b2-after-b3-margin-top-desktop: 11px;
                    --cs-theme-b2-after-l2-margin-top-mobile: 13px;
                    --cs-theme-b2-after-l2-margin-top-tablet-landscape: 21px;
                    --cs-theme-b2-after-l2-margin-top-desktop: 29px;
                    --cs-theme-b3-font-size-mobile: 14px;
                    --cs-theme-b3-font-size-desktop: 16px;
                    --cs-theme-b3-letter-spacing-mobile: normal;
                    --cs-theme-b3-letter-spacing-tablet-portrait: normal;
                    --cs-theme-b3-letter-spacing-desktop: normal;
                    --cs-theme-b3-line-height-mobile: 20px;
                    --cs-theme-b3-line-height-desktop: 24px;
                    --cs-theme-b3-margin-mobile: 12px 0;
                    --cs-theme-b3-margin-desktop: 16px 0;
                    --cs-theme-b3-after-d4-margin-top-mobile: 13px;
                    --cs-theme-b3-after-d4-margin-top-desktop: 10px;
                    --cs-theme-b3-after-h5-margin-top-mobile: 8px;
                    --cs-theme-b3-after-h5-margin-top-tablet-landscape: 7px;
                    --cs-theme-b3-after-h5-margin-top-desktop: 9px;
                    --cs-theme-b3-after-h6-margin-top-mobile: 8px;
                    --cs-theme-b3-after-h6-margin-top-desktop: 9px;
                    --cs-theme-b3-after-b2-margin-top-mobile: 5px;
                    --cs-theme-b3-after-b2-margin-top-tablet-landscape: 9px;
                    --cs-theme-b3-after-b2-margin-top-desktop: 10px;
                    --cs-theme-l1-font-weight: bold;
                    --cs-theme-l1-letter-spacing: .5px;
                    --cs-theme-l1-font-size-mobile: 28px;
                    --cs-theme-l1-font-size-tablet-landscape: var(--cs-theme-l1-font-size-mobile);
                    --cs-theme-l1-font-size-desktop: 32px;
                    --cs-theme-l1-line-height-mobile: 32px;
                    --cs-theme-l1-line-height-tablet-landscape: var(--cs-theme-l1-line-height-mobile);
                    --cs-theme-l1-line-height-desktop: 32px;
                    --cs-theme-l1-margin-mobile: 24px 0;
                    --cs-theme-l1-margin-tablet-landscape: var(--cs-theme-l1-margin-mobile);
                    --cs-theme-l1-margin-desktop: 32px 0;
                    --cs-theme-l2-font-weight: bold;
                    --cs-theme-l2-font-size-mobile: 16px;
                    --cs-theme-l2-font-size-tablet-landscape: var(--cs-theme-l2-font-size-mobile);
                    --cs-theme-l2-font-size-desktop: 20px;
                    --cs-theme-l2-line-height-mobile: 20px;
                    --cs-theme-l2-line-height-tablet-landscape: var(--cs-theme-l2-line-height-mobile);
                    --cs-theme-l2-line-height-desktop: 24px;
                    --cs-theme-l2-margin-mobile: 24px 0;
                    --cs-theme-l2-margin-tablet-landscape: var(--cs-theme-l2-margin-mobile);
                    --cs-theme-l2-margin-desktop: 32px 0;
                    --cs-theme-countdown-clock-digit-font-family: var(--cs-theme-secondary-font-family);
                    --cs-theme-countdown-clock-digit-font-size: 140px;
                    --cs-theme-countdown-clock-digit-text-anchor: middle;
                    --cs-theme-countdown-clock-units-font-family: var(--cs-theme-primary-font-family);
                    --cs-theme-countdown-clock-units-font-size: 24px;
                    --cs-theme-countdown-clock-units-text-anchor: middle;
                    --cs-theme-countdown-clock-units-text-transform: uppercase;
                    --cs-theme-local-nav-font-color-light: var(--cs-light-color);
                    --cs-theme-local-nav-font-color-dark: var(--cs-dark-color);
                    --cs-theme-local-nav-font-color-hover: var(--cs-theme-secondary-color);
                    --cs-theme-local-nav-shelf-header-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                    --cs-theme-local-nav-shelf-header-font-size-tablet-landscape: var(--cs-theme-body-font-size-tablet-landscape);
                    --cs-theme-local-nav-shelf-header-font-size-desktop: var(--cs-theme-body-font-size-desktop);
                    --cs-theme-local-nav-shelf-header-letter-spacing-mobile: var(--cs-theme-body-letter-spacing-mobile);
                    --cs-theme-local-nav-shelf-header-letter-spacing-tablet-landscape: var(--cs-theme-body-letter-spacing-tablet-landscape);
                    --cs-theme-local-nav-shelf-header-letter-spacing-landscape: var(--cs-theme-body-letter-spacing-landscape);
                    --cs-theme-local-nav-shelf-header-font-family: var(--cs-theme-secondary-font-family);
                    --cs-theme-local-nav-shelf-link-current-dark-color: #585858;
                    --cs-theme-local-nav-shelf-link-current-light-color: #a3a3a3;
                    --cs-theme-local-nav-shelf-link-current-hover-dark-color: var(--cs-dark-color);
                    --cs-theme-local-nav-shelf-link-current-hover-light-color: var(--cs-light-color);
                    --cs-theme-local-nav-shelf-featured-link-current-dark-color: #585858;
                    --cs-theme-local-nav-shelf-featured-link-current-light-color: #a3a3a3;
                    --cs-theme-local-nav-shelf-featured-link-current-hover-dark-color: var(--cs-dark-color);
                    --cs-theme-local-nav-shelf-featured-link-current-hover-light-color: var(--cs-light-color);
                    --cs-theme-local-nav-cta-dropdown-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                    --cs-theme-local-nav-cta-dropdown-font-size-tablet-landscape: var(--cs-theme-body-font-size-tablet-landscape);
                    --cs-theme-local-nav-cta-dropdown-font-size-desktop: var(--cs-theme-body-font-size-desktop);
                    --cs-theme-local-nav-cta-dropdown-letter-spacing-mobile: var(--cs-theme-body-letter-spacing-mobile);
                    --cs-theme-local-nav-cta-dropdown-letter-spacing-tablet-landscape: var(--cs-theme-body-letter-spacing-tablet-landscape);
                    --cs-theme-local-nav-cta-dropdown-letter-spacing-landscape: var(--cs-theme-body-letter-spacing-landscape);
                    --cs-theme-local-nav-cta-dropdown-font-family: var(--cs-theme-primary-font-family);
                    --cs-theme-local-nav-shelf-sub-nav-font-family: var(--cs-theme-primary-font-family);
                    --cs-theme-local-nav-shelf-sub-nav-section-font-size-mobile: 16px;
                    --cs-theme-local-nav-shelf-sub-nav-section-font-size-tablet-landscape: 16px;
                    --cs-theme-local-nav-shelf-sub-nav-section-font-size-desktop: 16px;
                    --cs-theme-local-nav-shelf-sub-nav-section-title-font-color-light: var(--cs-light-color);
                    --cs-theme-local-nav-shelf-sub-nav-section-title-font-color-dark: var(--cs-dark-color);
                    --cs-theme-local-nav-shelf-sub-nav-link-font-size-mobile: 16px;
                    --cs-theme-local-nav-shelf-sub-nav-link-font-size-tablet-landscape: 16px;
                    --cs-theme-local-nav-shelf-sub-nav-link-font-size-desktop: 16px;
                    --cs-theme-local-nav-drawer-link-current-dark-color: #585858;
                    --cs-theme-local-nav-drawer-link-current-light-color: #a3a3a3;
                    --cs-theme-local-nav-drawer-link-current-hover-dark-color: var(--cs-dark-color);
                    --cs-theme-local-nav-drawer-link-current-hover-light-color: var(--cs-light-color);
                    --cs-theme-local-nav-drawer-sub-link-current-dark-color: #585858;
                    --cs-theme-local-nav-drawer-sub-link-current-light-color: #a3a3a3;
                    --cs-theme-local-nav-drawer-sub-link-current-hover-dark-color: var(--cs-dark-color);
                    --cs-theme-local-nav-drawer-sub-link-current-hover-light-color: var(--cs-light-color);
                    --cs-theme-dropdown-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                    --cs-theme-dropdown-font-size-tablet-landscape: var(--cs-theme-body-font-size-tablet-landscape);
                    --cs-theme-dropdown-line-height-mobile: var(--cs-theme-body-line-height-mobile);
                    --cs-theme-dropdown-line-height-tablet-landscape: var(--cs-theme-body-line-height-tablet-landscape);
                    --cs-theme-agegate-cover: var(--cs-dark-color);
                    --cs-theme-agegate-cover-icon: var(--cs-light-color);
                    --cs-theme-agegate-cover-icon-hover: var(--cs-theme-color);
                    --cs-theme-sub-nav-font-size-mobile: var(--cs-theme-body-font-size-mobile);
                    --cs-theme-sub-nav-font-size-tablet-portrait: var(--cs-theme-body-font-size-mobile);
                    --cs-theme-sub-nav-font-size-tablet-landscape: var(--cs-theme-body-font-size-tablet-landscape);
                    --cs-theme-sub-nav-font-size-desktop: var(--cs-theme-body-font-size-desktop);
                    --cs-theme-sub-nav-letter-spacing-mobile: var(--cs-theme-body-letter-spacing-mobile);
                    --cs-theme-sub-nav-letter-spacing-tablet-portrait: var(--cs-theme-body-letter-spacing-mobile);
                    --cs-theme-sub-nav-letter-spacing-tablet-landscape: var(--cs-theme-body-letter-spacing-tablet-landscape);
                    --cs-theme-sub-nav-letter-spacing-desktop: var(--cs-theme-body-letter-spacing-desktop);
                    --cs-theme-catalog-text-shadow: none;
                    --cs-theme-tile-text-shadow: var(--cs-theme-catalog-text-shadow);
                    --cs-theme-describe-text-shadow: none;
                    --cs-theme-header-text-shadow: var(--cs-theme-describe-text-shadow);
                    --cs-theme-subheading-text-shadow: var(--cs-theme-describe-text-shadow);
                    --cs-theme-promote-text-shadow: none;
                    --cs-theme-featured-content-text-shadow: var(--cs-theme-promote-text-shadow);
                    --cs-theme-hero-text-shadow: var(--cs-theme-promote-text-shadow);
                    --cs-theme-highlight-media-text-shadow: var(--cs-theme-promote-text-shadow);
                    --cs-theme-pitch-text-shadow: var(--cs-theme-promote-text-shadow);
                    --cs-theme-tout-text-shadow: var(--cs-theme-promote-text-shadow);
                    --cs-theme-tabs-background-color: #6801d7;
                    --cs-theme-tabs-indicator-color: #fe1d3b;
                    --cs-theme-tabs-interface-color: #fff;
                    --cs-theme-tabs-unselected-type: rgba(255, 255, 255, 0.5);
                    --cs-theme-tabs-selected-type: #fff;
                    --cs-theme-tabs-selected-state: rgba(255, 255, 255, 0.08);
                    --cs-theme-tabs-accent-elements: rgba(0, 0, 0, 0.08);
                    --cs-theme-tabs-inactive-interface-color: rgba(255, 255, 255, 0.1);
                    --cs-theme-tabs-tab-text-transform: capitalize;
                    --cs-theme-spacer-height: 32px;
                    --cs-theme-spacer-height-mobile: 40px;
                    --cs-theme-spacer-height-tablet-portrait: 56px;
                    --cs-theme-spacer-height-tablet-landscape: 64px;
                    --cs-theme-spacer-height-desktop: 80px
                }




                :host {
                    --cs-dark-color: #171717;
                    --cs-light-color: #eee;
                    --cs-dark-color-rgb: 22, 22, 22;
                    --cs-light-color-rgb: 243, 243, 243;
                    --origin-brand-color: #f56c2c;
                    --cs-access-brand-color: #2d3c51;
                    --xbox-brand-color: #52b043;
                    --playstation-brand-color: #003087;
                    --nintendo-brand-color: #fe0016;
                    --cs-success-color: #00dc8f;
                    --cs-error-color: #ff6969;
                    --mdc-theme-error: #ff6969;

                    --cs-theme-translucent-foreground: hsl(0, 0%, 98%);
                    --cs-theme-color: #2d3c51;
                    --cs-theme-secondary-color: #47886a;
                    --cs-color-black: #000;
                    --cs-color-blue: #2d3c51;
                    --cs-color-dark-blue: #232F3E;
                    --cs-color-dark-blue-hard: #131A22;
                    --cs-color-gray: #a3a3a3;
                    --cs-color-light-gray: #f3f3f3;
                    --cs-color-white: #fff;
                    --cs-color-xbox-green: #029e10;
                }




                :host {
                    --cs-zero: 0;
                    --cs-rail-mobile: 7.5vw;
                    --cs-rail-tablet-portrait: 7.8125vw;
                    --cs-rail-tablet-landscape: 7.4218vw;
                    --cs-rail-desktop: calc((100vw - 1420px) / 2);
                    --cs-gutter-mobile: 16px;
                    --cs-gutter-tablet-portrait: 24px;
                    --cs-gutter-tablet-landscape: 28px;
                    --cs-gutter-desktop: 32px;
                    --cs-column-mobile: calc((100vw - 2 * var(--cs-rail-mobile) - var(--cs-gutter-mobile) * 5) / 6);
                    --cs-column-tablet-portrait: calc((100vw - 2 * var(--cs-rail-tablet-portrait) - var(--cs-gutter-tablet-portrait) * 11) / 12);
                    --cs-column-tablet-landscape: calc((100vw - 2 * var(--cs-rail-tablet-landscape) - var(--cs-gutter-tablet-landscape) * 11) / 12);
                    --cs-column-desktop: calc((100vw - 2 * var(--cs-rail-desktop) - var(--cs-gutter-desktop) * 11) / 12);
                    --cs-column-mobile-with-rail: calc((100vw - (var(--cs-gutter-mobile) * 5 + var(--cs-rail-mobile) * 2)) / 6);
                    --cs-column-tablet-portrait-with-rail: calc((100vw - (var(--cs-gutter-tablet-portrait) * 11 + var(--cs-rail-tablet-portrait) * 2)) / 12);
                    --cs-column-tablet-landscape-with-rail: calc((100vw - (var(--cs-gutter-tablet-landscape) * 11 + var(--cs-rail-tablet-landscape) * 2)) / 12);
                    --cs-column-desktop-with-rail: calc((100vw - (var(--cs-gutter-desktop) * 11 + var(--cs-rail-desktop) * 2)) / 12);
                    --cs-small-component-space-mobile: 24px;
                    --cs-small-component-space-tablet-portrait: 28px;
                    --cs-small-component-space-tablet-landscape: 32px;
                    --cs-small-component-space-desktop: 36px;
                    --cs-medium-component-space-mobile: 40px;
                    --cs-medium-component-space-tablet-portrait: 48px;
                    --cs-medium-component-space-tablet-landscape: 56px;
                    --cs-medium-component-space-desktop: 64px;
                    --cs-large-component-space-mobile: 72px;
                    --cs-large-component-space-tablet-portrait: 82px;
                    --cs-large-component-space-tablet-landscape: 92px;
                    --cs-large-component-space-desktop: 112px;
                }




                :host {
                    --cs-modal-layer: 102;
                    --cs-network-nav-layer: 300;
                    --cs-local-nav-layer: 101;
                    --cs-sub-nav-layer: 100;
                    --cs-filter-layer: 99;
                }



                :host {
                    --layout: {
                        display: -ms-flexbox;
                        display: -webkit-flex;
                        display: flex
                    }

                    ;

                    --layout-inline: {
                        display: -ms-inline-flexbox;
                        display: -webkit-inline-flex;
                        display: inline-flex
                    }

                    ;

                    --layout-horizontal: {
                        @apply --layout;
                        -ms-flex-direction: row;
                        -webkit-flex-direction: row;
                        flex-direction: row
                    }

                    ;

                    --layout-horizontal-reverse: {
                        @apply --layout;
                        -ms-flex-direction: row-reverse;
                        -webkit-flex-direction: row-reverse;
                        flex-direction: row-reverse
                    }

                    ;

                    --layout-vertical: {
                        @apply --layout;
                        -ms-flex-direction: column;
                        -webkit-flex-direction: column;
                        flex-direction: column
                    }

                    ;

                    --layout-vertical-reverse: {
                        @apply --layout;
                        -ms-flex-direction: column-reverse;
                        -webkit-flex-direction: column-reverse;
                        flex-direction: column-reverse
                    }

                    ;

                    --layout-wrap: {
                        -ms-flex-wrap: wrap;
                        -webkit-flex-wrap: wrap;
                        flex-wrap: wrap
                    }

                    ;

                    --layout-wrap-reverse: {
                        -ms-flex-wrap: wrap-reverse;
                        -webkit-flex-wrap: wrap-reverse;
                        flex-wrap: wrap-reverse
                    }

                    ;

                    --layout-flex-auto: {
                        -ms-flex: 1 1 auto;
                        -webkit-flex: 1 1 auto;
                        flex: 1 1 auto
                    }

                    ;

                    --layout-flex-none: {
                        -ms-flex: none;
                        -webkit-flex: none;
                        flex: none
                    }

                    ;

                    --layout-flex: {
                        -ms-flex: 1 1 .000000001px;
                        -webkit-flex: 1;
                        flex: 1;
                        -webkit-flex-basis: .000000001px;
                        flex-basis: .000000001px
                    }

                    ;

                    --layout-flex-2: {
                        -ms-flex: 2;
                        -webkit-flex: 2;
                        flex: 2
                    }

                    ;

                    --layout-flex-3: {
                        -ms-flex: 3;
                        -webkit-flex: 3;
                        flex: 3
                    }

                    ;

                    --layout-flex-4: {
                        -ms-flex: 4;
                        -webkit-flex: 4;
                        flex: 4
                    }

                    ;

                    --layout-flex-5: {
                        -ms-flex: 5;
                        -webkit-flex: 5;
                        flex: 5
                    }

                    ;

                    --layout-flex-6: {
                        -ms-flex: 6;
                        -webkit-flex: 6;
                        flex: 6
                    }

                    ;

                    --layout-flex-7: {
                        -ms-flex: 7;
                        -webkit-flex: 7;
                        flex: 7
                    }

                    ;

                    --layout-flex-8: {
                        -ms-flex: 8;
                        -webkit-flex: 8;
                        flex: 8
                    }

                    ;

                    --layout-flex-9: {
                        -ms-flex: 9;
                        -webkit-flex: 9;
                        flex: 9
                    }

                    ;

                    --layout-flex-10: {
                        -ms-flex: 10;
                        -webkit-flex: 10;
                        flex: 10
                    }

                    ;

                    --layout-flex-11: {
                        -ms-flex: 11;
                        -webkit-flex: 11;
                        flex: 11
                    }

                    ;

                    --layout-flex-12: {
                        -ms-flex: 12;
                        -webkit-flex: 12;
                        flex: 12
                    }

                    ;

                    --layout-start: {
                        -ms-flex-align: start;
                        -webkit-align-items: flex-start;
                        align-items: flex-start
                    }

                    ;

                    --layout-center: {
                        -ms-flex-align: center;
                        -webkit-align-items: center;
                        align-items: center
                    }

                    ;

                    --layout-end: {
                        -ms-flex-align: end;
                        -webkit-align-items: flex-end;
                        align-items: flex-end
                    }

                    ;

                    --layout-baseline: {
                        -ms-flex-align: baseline;
                        -webkit-align-items: baseline;
                        align-items: baseline
                    }

                    ;

                    --layout-start-justified: {
                        -ms-flex-pack: start;
                        -webkit-justify-content: flex-start;
                        justify-content: flex-start
                    }

                    ;

                    --layout-center-justified: {
                        -ms-flex-pack: center;
                        -webkit-justify-content: center;
                        justify-content: center
                    }

                    ;

                    --layout-end-justified: {
                        -ms-flex-pack: end;
                        -webkit-justify-content: flex-end;
                        justify-content: flex-end
                    }

                    ;

                    --layout-around-justified: {
                        -ms-flex-pack: distribute;
                        -webkit-justify-content: space-around;
                        justify-content: space-around
                    }

                    ;

                    --layout-justified: {
                        -ms-flex-pack: justify;
                        -webkit-justify-content: space-between;
                        justify-content: space-between
                    }

                    ;

                    --layout-center-center: {
                        @apply --layout-center;
                        @apply --layout-center-justified;
                    }

                    ;

                    --layout-self-start: {
                        -ms-align-self: flex-start;
                        -webkit-align-self: flex-start;
                        align-self: flex-start
                    }

                    ;

                    --layout-self-center: {
                        -ms-align-self: center;
                        -webkit-align-self: center;
                        align-self: center
                    }

                    ;

                    --layout-self-end: {
                        -ms-align-self: flex-end;
                        -webkit-align-self: flex-end;
                        align-self: flex-end
                    }

                    ;

                    --layout-self-stretch: {
                        -ms-align-self: stretch;
                        -webkit-align-self: stretch;
                        align-self: stretch
                    }

                    ;

                    --layout-self-baseline: {
                        -ms-align-self: baseline;
                        -webkit-align-self: baseline;
                        align-self: baseline
                    }

                    ;

                    --layout-start-aligned: {
                        -ms-flex-line-pack: start;
                        -ms-align-content: flex-start;
                        -webkit-align-content: flex-start;
                        align-content: flex-start
                    }

                    ;

                    --layout-end-aligned: {
                        -ms-flex-line-pack: end;
                        -ms-align-content: flex-end;
                        -webkit-align-content: flex-end;
                        align-content: flex-end
                    }

                    ;

                    --layout-center-aligned: {
                        -ms-flex-line-pack: center;
                        -ms-align-content: center;
                        -webkit-align-content: center;
                        align-content: center
                    }

                    ;

                    --layout-between-aligned: {
                        -ms-flex-line-pack: justify;
                        -ms-align-content: space-between;
                        -webkit-align-content: space-between;
                        align-content: space-between
                    }

                    ;

                    --layout-around-aligned: {
                        -ms-flex-line-pack: distribute;
                        -ms-align-content: space-around;
                        -webkit-align-content: space-around;
                        align-content: space-around
                    }

                    ;

                    --layout-block: {
                        display: block
                    }

                    ;

                    --layout-invisible: {
                        visibility: hidden !important
                    }

                    ;

                    --layout-relative: {
                        position: relative
                    }

                    ;

                    --layout-fit: {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0
                    }

                    ;

                    --layout-scroll: {
                        -webkit-overflow-scrolling: touch;
                        overflow: auto
                    }

                    ;

                    --layout-fullbleed: {
                        margin: 0;
                        height: 100vh
                    }

                    ;

                    --layout-fixed-top: {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0
                    }

                    ;

                    --layout-fixed-right: {
                        position: fixed;
                        top: 0;
                        right: 0;
                        bottom: 0
                    }

                    ;

                    --layout-fixed-bottom: {
                        position: fixed;
                        right: 0;
                        bottom: 0;
                        left: 0
                    }

                    ;

                    --layout-fixed-left: {
                        position: fixed;
                        top: 0;
                        bottom: 0;
                        left: 0
                    }

                    ;
                }




                .h1,
                .h2,
                .h3,
                .h4,
                .h5,
                .h6,
                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    transition: opacity var(--cs-interface-expansion)
                }

                :host([wf-loading]) .h1,
                :host([wf-loading]) .h2,
                :host([wf-loading]) .h3,
                :host([wf-loading]) .h4,
                :host([wf-loading]) .h5,
                :host([wf-loading]) .h6,
                :host([wf-loading]) h1,
                :host([wf-loading]) h2,
                :host([wf-loading]) h3,
                :host([wf-loading]) h4,
                :host([wf-loading]) h5,
                :host([wf-loading]) h6 {
                    opacity: 0
                }

                .h1-brand-light,
                .h1-light,
                .h2-brand-light,
                .h2-light,
                .h3-brand-light,
                .h3-light,
                .h4-brand-light,
                .h4-light,
                .h5-brand-light,
                .h5-light,
                .h6-brand-light,
                .h6-light {
                    color: var(--cs-light-color)
                }

                .h1,
                h1 {
                    font-size: var(--cs-theme-h1-font-size-mobile);
                    font-weight: var(--cs-theme-h1-font-weight);
                    letter-spacing: var(--cs-theme-h1-letter-spacing-mobile);
                    line-height: var(--cs-theme-h1-line-height-mobile)
                }

                h1 {
                    margin: var(--cs-theme-h1-margin-mobile)
                }

                @media only screen and (min-width:768px) {
                    h1 {
                        margin: var(--cs-theme-h1-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h1,
                    h1 {
                        font-size: var(--cs-theme-h1-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h1-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h1-line-height-tablet-landscape)
                    }

                    h1 {
                        margin: var(--cs-theme-h1-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h1,
                    h1 {
                        font-size: var(--cs-theme-h1-font-size-desktop);
                        letter-spacing: var(--cs-theme-h1-letter-spacing-desktop);
                        line-height: var(--cs-theme-h1-line-height-desktop)
                    }

                    h1 {
                        margin: var(--cs-theme-h1-margin-desktop)
                    }

                }

                .h2,
                h2 {
                    font-size: var(--cs-theme-h2-font-size-mobile);
                    font-weight: var(--cs-theme-h2-font-weight);
                    letter-spacing: var(--cs-theme-h2-letter-spacing-mobile);
                    line-height: var(--cs-theme-h2-line-height-mobile)
                }

                h2 {
                    margin: var(--cs-theme-h2-margin-mobile)
                }

                .l2:not([hidden])+.h2 {
                    margin-top: var(--cs-theme-h2-after-l2-margin-top-mobile)
                }

                @media only screen and (min-width:768px) {
                    h2 {
                        margin: var(--cs-theme-h2-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h2,
                    h2 {
                        font-size: var(--cs-theme-h2-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h2-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h2-line-height-tablet-landscape)
                    }

                    h2 {
                        margin: var(--cs-theme-h2-margin-tablet-landscape)
                    }

                    .l2:not([hidden])+.h2 {
                        margin-top: var(--cs-theme-h2-after-l2-margin-top-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h2,
                    h2 {
                        font-size: var(--cs-theme-h2-font-size-desktop);
                        letter-spacing: var(--cs-theme-h2-letter-spacing-desktop);
                        line-height: var(--cs-theme-h2-line-height-desktop)
                    }

                    h2 {
                        margin: var(--cs-theme-h2-margin-desktop)
                    }

                    .l2:not([hidden])+.h2 {
                        margin-top: var(--cs-theme-h2-after-l2-margin-top-desktop)
                    }

                }

                .h3,
                h3 {
                    font-size: var(--cs-theme-h3-font-size-mobile);
                    font-weight: var(--cs-theme-h3-font-weight);
                    letter-spacing: var(--cs-theme-h3-letter-spacing-mobile);
                    line-height: var(--cs-theme-h3-line-height-mobile)
                }

                h3 {
                    margin: var(--cs-theme-h3-margin-mobile)
                }

                @media only screen and (min-width:768px) {
                    h3 {
                        margin: var(--cs-theme-h3-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h3,
                    h3 {
                        font-size: var(--cs-theme-h3-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h3-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h3-line-height-tablet-landscape)
                    }

                    h3 {
                        margin: var(--cs-theme-h3-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h3,
                    h3 {
                        font-size: var(--cs-theme-h3-font-size-desktop);
                        letter-spacing: var(--cs-theme-h3-letter-spacing-desktop);
                        line-height: var(--cs-theme-h3-line-height-desktop)
                    }

                    h3 {
                        margin: var(--cs-theme-h3-margin-desktop)
                    }

                }

                .h4,
                h4 {
                    font-size: var(--cs-theme-h4-font-size-mobile);
                    font-weight: var(--cs-theme-h4-font-weight);
                    letter-spacing: var(--cs-theme-h4-letter-spacing-mobile);
                    line-height: var(--cs-theme-h4-line-height-mobile)
                }

                h4 {
                    margin: var(--cs-theme-h4-margin-mobile)
                }

                .d1:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d1-margin-top-mobile)
                }

              .d2:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d2-margin-top-mobile)
                }

                .d3:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d3-margin-top-mobile)
                }

                .d4:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-d4-margin-top-mobile)
                }

                .l2:not([hidden])+.h4 {
                    margin-top: var(--cs-theme-h4-after-l2-margin-top-mobile)
                }

                img+dom-if+.h4,
                img+dom-if+[hidden]+.h4 {
                    margin-top: 26px
                }

                @media only screen and (min-width:768px) {
                    .d1:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d1-margin-top-tablet-portrait)
                    }

                    .d2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d2-margin-top-tablet-portrait)
                    }

                    .d3:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d3-margin-top-tablet-portrait)
                    }

                }

                @media only screen and (min-width:768px) {
                    h4 {
                        margin: var(--cs-theme-h4-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h4,
                    h4 {
                        font-size: var(--cs-theme-h4-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h4-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h4-line-height-tablet-landscape)
                    }

                    h4 {
                        margin: var(--cs-theme-h4-margin-tablet-landscape)
                    }

                    .d1:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d1-margin-top-tablet-landscape)
                    }

                    .d2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d2-margin-top-tablet-landscape)
                    }

                    .d3:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d3-margin-top-tablet-landscape)
                    }

                    .d4:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d4-margin-top-tablet-landscape)
                    }

                    .l2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-l2-margin-top-tablet-landscape)
                    }

                    img+dom-if+.h4,
                    img+dom-if+[hidden]+.h4 {
                        margin-top: 32px
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h4,
                    h4 {
                        font-size: var(--cs-theme-h4-font-size-desktop);
                        letter-spacing: var(--cs-theme-h4-letter-spacing-desktop);
                        line-height: var(--cs-theme-h4-line-height-desktop)
                    }

                    h4 {
                        margin: var(--cs-theme-h4-margin-desktop)
                    }

                    .d1:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d1-margin-top-desktop)
                    }

                    .d3:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d3-margin-top-desktop)
                    }

                    .d4:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-d4-margin-top-desktop)
                    }

                    .l2:not([hidden])+.h4 {
                        margin-top: var(--cs-theme-h4-after-l2-margin-top-desktop)
                    }

                    img+dom-if+.h4,
                    img+dom-if+[hidden]+.h4 {
                        margin-top: 40px
                    }

                }

                .h5,
                h5 {
                    font-size: var(--cs-theme-h5-font-size-mobile);
                    font-weight: var(--cs-theme-h5-font-weight);
                    letter-spacing: var(--cs-theme-h5-letter-spacing-mobile);
                    line-height: var(--cs-theme-h5-line-height-mobile)
                }

                h5 {
                    margin: var(--cs-theme-h5-margin-mobile)
                }

                .l2:not([hidden])+.h5 {
                    margin-top: var(--cs-theme-h5-after-l2-margin-top-mobile)
                }

                @media only screen and (min-width:768px) {
                    h5 {
                        margin: var(--cs-theme-h5-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {

                    .h5,
                    h5 {
                        font-size: var(--cs-theme-h5-font-size-tablet-landscape);
                        letter-spacing: var(--cs-theme-h5-letter-spacing-tablet-landscape);
                        line-height: var(--cs-theme-h5-line-height-tablet-landscape)
                    }

                    h5 {
                        margin: var(--cs-theme-h5-margin-tablet-landscape)
                    }

                    .l2:not([hidden])+.h5 {
                        margin-top: var(--cs-theme-h5-after-l2-margin-top-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h5,
                    h5 {
                        font-size: var(--cs-theme-h5-font-size-desktop);
                        letter-spacing: var(--cs-theme-h5-letter-spacing-desktop);
                        line-height: var(--cs-theme-h5-line-height-desktop)
                    }

                    h5 {
                        margin: var(--cs-theme-h5-margin-desktop)
                    }

                    .l2:not([hidden])+.h5 {
                        margin-top: var(--cs-theme-h5-after-l2-margin-top-desktop)
                    }

                }

                .h6,
                h6 {
                    font-size: var(--cs-theme-h6-font-size-mobile);
                    font-weight: var(--cs-theme-h6-font-weight);
                    letter-spacing: var(--cs-theme-h6-letter-spacing-mobile);
                    line-height: var(--cs-theme-h6-line-height-mobile)
                }

                h6 {
                    margin: var(--cs-theme-h6-margin-mobile)
                }

                .d3:not([hidden])+.h6 {
                    margin-top: var(--cs-theme-h6-after-d3-margin-top-mobile)
                }

                .l2:not([hidden])+.h6 {
                    margin-top: var(--cs-theme-h6-after-l2-margin-top-mobile)
                }

                @media only screen and (min-width:768px) {
                    h6 {
                        margin: var(--cs-theme-h6-margin-tablet-portrait)
                    }

                }

                @media only screen and (min-width:1024px) {
                    h6 {
                        margin: var(--cs-theme-h6-margin-tablet-landscape)
                    }

                    .d3:not([hidden])+.h6 {
                        margin-top: var(--cs-theme-h6-after-d3-margin-top-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {

                    .h6,
                    h6 {
                        font-size: var(--cs-theme-h6-font-size-desktop);
                        letter-spacing: var(--cs-theme-h6-letter-spacing-desktop);
                        line-height: var(--cs-theme-h6-line-height-desktop)
                    }

                    h6 {
                        margin: var(--cs-theme-h6-margin-desktop)
                    }

                    .d3:not([hidden])+.h6 {
                        margin-top: var(--cs-theme-h6-after-d3-margin-top-desktop)
                    }

                }




                .l1,
                .l2 {
                    font-family: var(--cs-theme-secondary-font-family);
                    transition: opacity var(--cs-interface-expansion)
                }

                :host([wf-loading]) .l1,
                :host([wf-loading]) .l2 {
                    opacity: 0
                }

                .l1-brand-light,
                .l1-light,
                .l2-brand-light,
                .l2-light {
                    color: var(--cs-light-color)
                }

                .l1 {
                    font-size: var(--cs-theme-l1-font-size-mobile);
                    font-weight: var(--cs-theme-l2-font-weight);
                    letter-spacing: var(--cs-theme-l1-letter-spacing);
                    line-height: var(--cs-theme-l1-line-height-mobile);
                    margin: var(--cs-theme-l1-margin-mobile);
                    text-transform: none
                }

                @media only screen and (min-width:1024px) {
                    .l1 {
                        font-size: var(--cs-theme-l1-font-size-tablet-landscape);
                        line-height: var(--cs-theme-l1-line-height-tablet-landscape);
                        margin: var(--cs-theme-l1-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {
                    .l1 {
                        font-size: var(--cs-theme-l1-font-size-desktop);
                        line-height: var(--cs-theme-l1-line-height-desktop);
                        margin: var(--cs-theme-l1-margin-desktop)
                    }

                }

                .l2 {
                    font-size: var(--cs-theme-l2-font-size-mobile);
                    font-weight: var(--cs-theme-l2-font-weight);
                    line-height: var(--cs-theme-l2-line-height-mobile);
                    margin: var(--cs-theme-l2-margin-mobile);
                    text-transform: none
                }

                @media only screen and (min-width:1024px) {
                    .l2 {
                        font-size: var(--cs-theme-l2-font-size-tablet-landscape);
                        line-height: var(--cs-theme-l2-line-height-tablet-landscape);
                        margin: var(--cs-theme-l2-margin-tablet-landscape)
                    }

                }

                @media only screen and (min-width:1456px) {
                    .l2 {
                        font-size: var(--cs-theme-l2-font-size-desktop);
                        line-height: var(--cs-theme-l2-line-height-desktop);
                        margin: var(--cs-theme-l2-margin-desktop)
                    }

                }

            </style>
		</custom-style>
	</template>
</dom-module>`;
document.head.appendChild($_documentContainer.content);
